/*
 * @Author: your name
 * @Date: 2020-07-20 09:59:37
 * @LastEditTime: 2020-07-23 18:16:52
 * @LastEditors: your name
 * @Description: In User Settings Edit
 * @FilePath: /xyf-mobile-frontend/src/utils/requestLand .js
 */
import axios from 'axios';
import {
  Toast
} from 'vant'
import {
  getQueryString,
  terminalFn,
  isIos,
  getTrafficTag,
} from './index';
const md5 = require('md5');
let ua = 'h5-client';
const key = 'd671bWa4R6F7Ps314'
const landBaseUrl = process.env.VUE_APP_GW + '/wechatoaprod';
const signKey = `${ua}${key}${ua}`;

let headers = { 'inner-app': 'xyf01', 'app': 'xyf01', 'App-Name': 'XYF01', Os: terminalFn(), 'Version-code': 40000, 'source-type': 'wap', 'device-id': '' };

export const requestLandProxyWeiXin = axios.create({
  baseURL: landBaseUrl,
  timeout: 10000,
  withCredentials: false,
  headers: {
    ...headers,
    'Content-Type': 'application/json',
    'App-Name': getQueryString('app_name') || 'xyf01',
    Os: terminalFn(),
  },
});
requestLandProxyWeiXin.interceptors.request.use(
  function (config) {
    let postdata = {
      ua: ua,
      args: {},
      sign: {},
      timestamp: '1642664673',
    };
    const { call } = config.data;
    // 检查是否支持 Object.entries() 和 Object.fromEntries()
    if (!Object.entries) {
      Object.entries = function(obj) {
        return Object.keys(obj).map(key => [key, obj[key]]);
      };
    }

    if (!Object.fromEntries) {
      Object.fromEntries = function(entries) {
        return entries.reduce((acc, [key, value]) => {
          acc[key] = value;
          return acc;
        }, {});
      };
    }
    let sortParams = Object.fromEntries(
      Object.entries(config.data.args).sort((a, b) => a[0].localeCompare(b[0]))
    );
    // let args = JSON.stringify(config.data.args);
    let args = JSON.stringify(sortParams);
    

    let str = `${signKey}${call}${signKey}${args}${signKey}`;
    console.log(str,'strrrrrrrrrrrrr')
    config.data.args = sortParams;
    let sign = md5(str);
    postdata.sign = sign;
    postdata = Object.assign(postdata, config.data);
    delete postdata.call;
    config.data = postdata;

    let REPORTTOKEN = localStorage.getItem('REPORT_TOKEN');
    let REPORTAPP = localStorage.getItem('REPORT_APP');
    let appName = sessionStorage.getItem('app_name');
    let utm_source = getQueryString('utm_source') || sessionStorage.getItem('utm_source')
    let arms_uid = localStorage.getItem('SESSIONTOKEN') ;
    if(arms_uid){
      config.headers['arms-uid'] = arms_uid + getQueryString('type');
      config.headers.Token = arms_uid;// 请求头加token
    }
    if (appName) {
      config.headers['App-Name'] = appName;
      config.headers['app'] = appName;
      config.headers['inner-app'] = appName;
    }
    if (utm_source) {
      config.headers['utm-source'] = utm_source;
    }
    if (REPORTTOKEN) {
      config.headers.Token = REPORTTOKEN;
    }
    if (REPORTAPP) {
      config.headers['App-Name'] = REPORTAPP;
      config.headers['app'] = REPORTAPP;
      config.headers['inner-app'] = REPORTAPP;
    }
    const trafficTag = getTrafficTag();
    if (trafficTag) config.headers['traffic-tag'] = trafficTag;
    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

requestLandProxyWeiXin.interceptors.response.use(
  response => {
    const responseData = response.data;
    return responseData;
  },
  function (error) {
    window.location.href= 'https://m-v6.xinyongfei.cn/activity/lost?from=min'
    return Promise.reject(error);
  }
);

// export default requestLand;